import type { TAsrExecutionAttempt, TAsrExecutionStage } from 'app/API/custom/asr-execution/types';
import { PROVIDER_RESPONSE_PHASE } from '../constants';

const QUEUED_PHASE = 1;
const PROVIDER_SUBMIT_PHASE = 4;

const FAILED_PHASE_BY_PRECEDING_STAGE: Record<string, number> = {
  request_received: QUEUED_PHASE,
  provider_selected: QUEUED_PHASE,
  model_selected: QUEUED_PHASE,
  params_validated: QUEUED_PHASE,
  params_built: QUEUED_PHASE,
  provider_submitted: PROVIDER_RESPONSE_PHASE,
  provider_polling: PROVIDER_RESPONSE_PHASE,
  provider_result_received: 6,
  transcript_mapped: 7,
  normalizers_applied: 8,
  quality_checked: 9,
};

export const getFailedRoutePhase = (
  stages: TAsrExecutionStage[] | undefined,
  attempts: TAsrExecutionAttempt[] = [],
): number => {
  const failedIndex = stages?.findIndex((stage) => stage.name === 'failed') ?? -1;
  if (!stages || failedIndex <= 0) {
    return PROVIDER_RESPONSE_PHASE;
  }
  const precedingStage = stages[failedIndex - 1].name;
  if (precedingStage === 'temporal_started') {
    return attempts.length > 0 ? PROVIDER_SUBMIT_PHASE : QUEUED_PHASE;
  }
  return FAILED_PHASE_BY_PRECEDING_STAGE[precedingStage] ?? PROVIDER_RESPONSE_PHASE;
};
